import { HotelResponseType } from "src/store/slices/hotels/Hotels";
export type HotelSelectOptionType = {
  type: "hotels" | "cities";
  label: string;
  value: string;
  subLabel: string;
  country?:string;
};
const mapOption = (data: HotelResponseType): HotelSelectOptionType => {
  return {
    type: data.indexUid,
    label: data.name,
    value: data.code,
    country:data?.countryCode,
    subLabel: data.cityName ? `${data.cityName}, ${data.countryName}`: `${data.countryName}`,
  };
};

export { mapOption };
